module.exports = __webpack_public_path__ + "static/img/sub.8a664b03.jpg";